import { ArrowLeft, CheckIcon, Close } from 'assets/icons';
import Button from 'components/button';
import EmptyState from 'components/EmptyState/EmptyState';
import UseModal from 'components/modal/useModal';
import StyledInput from 'components/styledInput/StyledInput';
import SubNavbar from 'components/SubNavbar/SubNavbar';
import Tooltip from 'components/tooltips/Tooltips';
import { dateWordMonth } from 'helper/helper';
import UseContext from 'hooks/useContext';
import useImportedTimeSheet from 'hooks/useImportedTimeSheet';
import useSlideOver from 'components/SlideOver/useSlideOver';
import TBodyHoursCompany from 'pages/timeSheet/components/tBodyHours';
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import ApiDatabase from 'server';
import MediaQuery from 'react-responsive';

const FicheHour = () => {
  const {
    setObjID,
    setObjType,
    refreshTime,
    setTotalH,
    content,
    timeCheck,
    setTimeCheck,
    setUpdatedTimesheet,
    setMissionInitialPage,
  } = UseContext();
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { toggleSlideOver } = useSlideOver();
  const [datas, setDatas] = useState([]);
  const [nMission, setNMission] = useState('');
  const [valid, setValid] = useState(true);
  const { toggle } = UseModal();
  const [allTimeSheetValid, setAllTimeSheetValid] = useState(false);
  const [allTimeSheetClose, setAllTimeSheetClose] = useState(false);
  const [isTimeSheetImported, setIsTimeSheetImported] = useState(false);
  const [isWaiting, setIsWaiting] = useState(true);
  const token = localStorage.getItem('xsrfToken');

  const { toggleImported } = useImportedTimeSheet();

  useEffect(() => {
    setIsWaiting(true);
    ApiDatabase.getTimeSheetInfo(
      { id },
      (data) => {
        setDatas(data);
        setObjID(data[0].id_time_sheet);
        setIsTimeSheetImported(data[0].is_imported_bestt);
        setIsWaiting(false);
      },
      (err) => {
        if (err.name !== 'CanceledError') {
          console.log(err);
          setIsWaiting(false);
        }
      }
    );
  }, [refreshTime, id]);

  useEffect(() => {
    if (datas.length > 0) {
      if (datas[0]?.id_mission) {
        ApiDatabase.getInfoMission(
          { id: datas[0]?.id_mission },
          (data) => {
            setNMission(data.title);
            setObjType(data.title);
          },
          (err) => {
            if (err.name !== 'CanceledError') {
              console.log(err);
            }
          }
        );
      }
    }
  }, [datas[0]?.id_mission]);

  const getSeconds = (s) =>
    s.split('h').reduce((acc, curr) => acc * 60 + +curr, 0);
  useEffect(() => {
    let res = 0;
    if (datas.length > 0) {
      datas[0]?.days.forEach((i) => {
        if (i.day_hours_ent) {
          res += getSeconds(i.day_hours_ent);
        }
        if (!i.validated) setValid(false);
        else setValid(true);
      });
    }
    setTotalH(res);
  }, [datas]);

  const handleSubmit = (e) => {
    if (valid) {
      toggle('doc_u_validWeek');
    } else {
      toast.error('Veuillez compléter la semaine');
    }
  };

  const allClose = () => {
    let validateTimeSheet = false;
    for (let i in timeCheck) {
      if (timeCheck[i] !== 2) {
        validateTimeSheet = true;
      }
    }
    if (validateTimeSheet) {
      for (let i in timeCheck) {
        setTimeCheck((prevData) => ({
          ...prevData,
          [i]: 2,
        }));
      }
    } else {
      for (let i in timeCheck) {
        setTimeCheck((prevData) => ({
          ...prevData,
          [i]: '',
        }));
      }
    }
  };

  const allValid = () => {
    let closeTimeSheet = false;
    for (let i in timeCheck) {
      if (timeCheck[i] !== 3) {
        closeTimeSheet = true;
      }
    }
    if (closeTimeSheet) {
      for (let i in timeCheck) {
        setTimeCheck((prevData) => ({
          ...prevData,
          [i]: 3,
        }));
      }
    } else {
      for (let i in timeCheck) {
        setTimeCheck((prevData) => ({
          ...prevData,
          [i]: '',
        }));
      }
    }
  };

  const handleNext = (e) => {
    e.preventDefault();
    let validateTimeSheet = true;
    for (let i in timeCheck) {
      if (timeCheck[i] === '') {
        validateTimeSheet = false;
      }
    }
    if (validateTimeSheet) {
      setObjID(id);
      toggle('doc_u_validWeek');
    } else {
      toast.error('Veuillez valider ou refuser toutes les heures.');
    }
  };

  useEffect(() => {
    setTimeCheck({});
    datas[0]?.days?.forEach((i) =>
      setTimeCheck((prevData) => ({
        ...prevData,
        [i._id]: '',
      }))
    );
  }, [datas]);

  useEffect(() => {
    let valid = true;
    let close = true;
    for (let i in timeCheck) {
      if (timeCheck[i] !== 2) {
        valid = false;
      }
      if (timeCheck[i] !== 3) {
        close = false;
      }
    }
    setAllTimeSheetValid(valid);
    setAllTimeSheetClose(close);
  }, [timeCheck]);

  // Remplacement de la fonction importBestt par handleToggleImported
  const handleToggleImported = (isImported, idTimeSheet) => {
    toggleImported(isImported, idTimeSheet, (imported) => {
      setDatas((prevData) =>
        prevData.map((item) =>
          item._id === idTimeSheet
            ? { ...item, is_imported_bestt: imported }
            : item
        )
      );
      setIsTimeSheetImported(imported);

      setUpdatedTimesheet((prev) => ({
        ...prev,
        [idTimeSheet]: imported,
      }));
    });
  };

  const openTempWorkerInfo = (id) => {
    setObjID(id);
    toggleSlideOver('get_temp_worker');
  };

  const openMissionInfo = () => {
    // Définir l'onglet initial à "Détail de mission" (page 3) quand on vient du relevé d'heures
    if (setMissionInitialPage) {
      setMissionInitialPage(3);
    }
    
    // Utiliser id_mission (ObjectId MongoDB) si disponible
    if (datas[0]?.id_mission) {
      setObjID(datas[0].id_mission);
      toggleSlideOver('get_mission');
    } else if (datas[0]?.id_mission_reel) {
      // Si on n'a que l'ID numérique, chercher la mission pour récupérer son ObjectId MongoDB
      ApiDatabase.searchMission(
        { token, search: datas[0].id_mission_reel.toString(), optionSearch: 'id_mission' },
        (data) => {
          if (data.missions && data.missions.length > 0) {
            // Utiliser l'ID MongoDB de la mission trouvée (id_mission_real)
            const mission = data.missions.find(m => m.id_mission === parseInt(datas[0].id_mission_reel) || m.id_mission?.toString() === datas[0].id_mission_reel?.toString());
            if (mission && mission.id_mission_real) {
              setObjID(mission.id_mission_real);
              toggleSlideOver('get_mission');
            } else if (data.missions[0].id_mission_real) {
              setObjID(data.missions[0].id_mission_real);
              toggleSlideOver('get_mission');
            }
          }
        },
        (err) => {
          console.error('Error fetching mission:', err);
        }
      );
    }
  };

  return (
    <div className="flex flex-col w-full h-full">
      {/* SubNavbar fixe en haut */}
      <SubNavbar>
        <div 
          className="flex items-center gap-3 cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            // Naviguer vers la liste des relevés d'heures
            navigate('/timeSheet');
          }}
        >
          <ArrowLeft w={16} color="#111827" />
          <div className="text-sm font-medium text-gray-900">
            Retour
          </div>
        </div>
        {datas.length > 0 && datas[0]?.validated === 3 && (
          <div className="border rounded py-2 px-4 text-sm import-button-fiche-hour">
            <label className="flex items-center gap-2 cursor-pointer">
              <StyledInput
                type="checkbox"
                checked={isTimeSheetImported}
                onChange={(e) =>
                  handleToggleImported(
                    e.target.checked,
                    datas[0]?._id
                  )
                }
              />
              <div>Importé</div>
            </label>
          </div>
        )}
      </SubNavbar>

      {/* Contenu scrollable */}
      <div className="flex-1 overflow-y-auto p-3 tab:p-4 lg:p-8">
        {isWaiting ? (
          // Skeleton loading
          <div className="flex flex-col gap-6 items-center justify-center tab:flex-row">
            <div className="w-full tab:max-w-[654px] bg-white flex flex-col gap-4 p-6 animate-pulse">
              <div className="h-8 bg-gray-200 rounded w-64 mb-4"></div>
              <div className="space-y-3">
                {[1, 2, 3, 4, 5].map((i) => (
                  <div key={i} className="h-12 bg-gray-200 rounded"></div>
                ))}
              </div>
            </div>
            <MediaQuery minWidth={1100}>
              <div className="w-full tab:w-[450px] bg-white rounded-xl border border-gray-100 p-6 animate-pulse">
                <div className="h-6 bg-gray-200 rounded w-32 mb-6"></div>
                <div className="space-y-4">
                  {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="h-5 bg-gray-200 rounded"></div>
                  ))}
                </div>
              </div>
            </MediaQuery>
          </div>
        ) : datas.length > 0 ? (
          <div className="flex flex-col gap-12 items-center justify-center tab:flex-row">
            {/* Existing TimeSheet Card */}
            <div className="w-full tab:max-w-[654px] bg-white flex flex-col gap-4 header-fiche-hour">
              <div className="flex flex-col gap-2">
                <h1 className="text-2xl font-bold text-gray-900">
                  Relevé d'heure n°{datas[0]?.id_time_sheet}
                </h1>
                <div className="flex justify-between items-center px-2 ft-2xl text-gray-900">
                  {datas[0]?.validated > 0 ? null : (
                    <Button size="SM" onClick={handleSubmit}>
                      Valider la semaine
                    </Button>
                  )}
                </div>
              </div>
              
              {/* Informations Card - Mobile/Tablet only, appears after title */}
              <MediaQuery maxWidth={1099}>
                <div className="w-full bg-white rounded-xl border border-gray-100 p-6">
                  <h3 className="font-bold text-lg text-gray-900 mb-6">Informations</h3>
                  
                  <div className="flex flex-col gap-6">
                    <div className="flex justify-between items-center text-sm">
                      <span className="font-bold text-gray-900">Période</span>
                      <span className="text-gray-500 font-medium">
                        {dateWordMonth(datas[0]?.periode_start)} {'>'} {dateWordMonth(datas[0]?.periode_end)}
                      </span>
                    </div>
                    
                    <div className="flex justify-between items-center text-sm">
                      <span className="font-bold text-gray-900">Intérimaire</span>
                      {(datas[0]?.id_user || datas[0]?.user?.id_user) ? (
                        <Tooltip text="Voir la fiche" placement="top">
                          <span 
                            className="text-gray-500 font-medium text-right max-w-[200px] truncate cursor-pointer hover:underline decoration-dashed transition-colors"
                            onClick={(e) => {
                              e.stopPropagation();
                              openTempWorkerInfo(datas[0]?.id_user || datas[0]?.user?.id_user);
                            }}
                          >
                            {datas[0]?.user?.firstname} {datas[0]?.user?.lastname}
                          </span>
                        </Tooltip>
                      ) : (
                        <span className="text-gray-500 font-medium text-right max-w-[200px] truncate">
                          {datas[0]?.user?.firstname} {datas[0]?.user?.lastname}
                        </span>
                      )}
                    </div>

                    <div className="flex justify-between items-center text-sm">
                      <span className="font-bold text-gray-900">Mission</span>
                      {(datas[0]?.id_mission || datas[0]?.id_mission_reel) ? (
                        <Tooltip text="Voir la mission" placement="top">
                          <span 
                            className="text-gray-500 font-medium text-right max-w-[200px] truncate cursor-pointer hover:underline decoration-dashed transition-colors"
                            onClick={(e) => {
                              e.stopPropagation();
                              openMissionInfo();
                            }}
                          >
                            {datas[0]?.mission?.title || nMission || content?.title || '-'}
                          </span>
                        </Tooltip>
                      ) : (
                        <span className="text-gray-500 font-medium text-right max-w-[200px] truncate">
                          {datas[0]?.mission?.title || nMission || content?.title || '-'}
                        </span>
                      )}
                    </div>

                    <div className="flex justify-between items-center text-sm">
                      <span className="font-bold text-gray-900">Contrat</span>
                      <span className="text-gray-500 font-medium text-right max-w-[200px] truncate">
                        {(datas[0]?.mission?.contract_company?.[0]?.id_bestt || datas[0]?.mission?.contract_tempworker?.[0]?.id_bestt) 
                          ? `n°${datas[0]?.mission?.contract_company?.[0]?.id_bestt || datas[0]?.mission?.contract_tempworker?.[0]?.id_bestt}`
                          : '-'}
                      </span>
                    </div>
                  </div>
                </div>
              </MediaQuery>
              <div className="flex items-center justify-between mb-4">
                <div className="flex gap-6 items-center ft-sm text-gray-700 font-medium">
                  JOUR
                  <span className="text-gray-500">
                    {datas[0]?.total_hours_ent
                      ? `heures travaillées (${datas[0]?.total_hours_ent})`
                      : null}
                  </span>
                </div>
                <div className="flex items-center justify-end gap-6">
                  {datas[0].validated !== 2 ? (
                    <div
                      onClick={allClose}
                      className={`flex items-center justify-center h-8 w-8 rounded-md ${
                        allTimeSheetValid ? 'bg-red-50' : ''
                      } cursor-pointer`}
                    >
                      <Close
                        wh={24}
                        color={allTimeSheetValid ? '#B91C1C' : '#374151'}
                      />
                    </div>
                  ) : (
                    ''
                  )}
                  <div
                    onClick={allValid}
                    className={`flex items-center justify-center h-8 w-8 rounded-md ${
                      allTimeSheetClose ? 'bg-green-100' : ''
                    } cursor-pointer`}
                  >
                    <CheckIcon
                      w={15}
                      color={allTimeSheetClose ? '#047857' : '#374151'}
                    />
                  </div>
                </div>
              </div>
              <TBodyHoursCompany champsBody={datas[0]} />
              <div className="flex">
                <div className="ml-auto">
                  <Button size="LG" onClick={handleNext}>
                    Confirmer
                  </Button>
                </div>
              </div>
            </div>

            {/* New Right Side Card - Informations - Desktop only */}
            <MediaQuery minWidth={1100}>
              <div className="w-full tab:w-[450px] flex-shrink-0 bg-white rounded-xl border border-gray-100 p-6 h-fit sticky top-24">
                <h3 className="font-bold text-lg text-gray-900 mb-6">Informations</h3>
                
                <div className="flex flex-col gap-6">
                  <div className="flex justify-between items-center text-sm">
                    <span className="font-bold text-gray-900">Période</span>
                    <span className="text-gray-500 font-medium">
                      {dateWordMonth(datas[0]?.periode_start)} {'>'} {dateWordMonth(datas[0]?.periode_end)}
                    </span>
                  </div>
                  
                  <div className="flex justify-between items-center text-sm">
                    <span className="font-bold text-gray-900">Intérimaire</span>
                    {(datas[0]?.id_user || datas[0]?.user?.id_user) ? (
                      <Tooltip text="Voir la fiche" placement="top">
                        <span 
                          className="text-gray-500 font-medium text-right max-w-[200px] truncate cursor-pointer hover:underline decoration-dashed transition-colors"
                          onClick={(e) => {
                            e.stopPropagation();
                            openTempWorkerInfo(datas[0]?.id_user || datas[0]?.user?.id_user);
                          }}
                        >
                          {datas[0]?.user?.firstname} {datas[0]?.user?.lastname}
                        </span>
                      </Tooltip>
                    ) : (
                      <span className="text-gray-500 font-medium text-right max-w-[200px] truncate">
                        {datas[0]?.user?.firstname} {datas[0]?.user?.lastname}
                      </span>
                    )}
                  </div>

                  <div className="flex justify-between items-center text-sm">
                    <span className="font-bold text-gray-900">Mission</span>
                    {(datas[0]?.id_mission || datas[0]?.id_mission_reel) ? (
                      <Tooltip text="Voir la mission" placement="top">
                        <span 
                          className="text-gray-500 font-medium text-right max-w-[200px] truncate cursor-pointer hover:underline decoration-dashed transition-colors"
                          onClick={(e) => {
                            e.stopPropagation();
                            openMissionInfo();
                          }}
                        >
                          {datas[0]?.mission?.title || nMission || content?.title || '-'}
                        </span>
                      </Tooltip>
                    ) : (
                      <span className="text-gray-500 font-medium text-right max-w-[200px] truncate">
                        {datas[0]?.mission?.title || nMission || content?.title || '-'}
                      </span>
                    )}
                  </div>

                  <div className="flex justify-between items-center text-sm">
                    <span className="font-bold text-gray-900">Contrat</span>
                    <span className="text-gray-500 font-medium text-right max-w-[200px] truncate">
                      {(datas[0]?.mission?.contract_company?.[0]?.id_bestt || datas[0]?.mission?.contract_tempworker?.[0]?.id_bestt) 
                        ? `n°${datas[0]?.mission?.contract_company?.[0]?.id_bestt || datas[0]?.mission?.contract_tempworker?.[0]?.id_bestt}`
                        : '-'}
                    </span>
                  </div>
                </div>
              </div>
            </MediaQuery>
          </div>
        ) : (
          <EmptyState type="time_sheet" />
        )}
      </div>
    </div>
  );
};

export default FicheHour;
